import React from 'react';
import { SITE_CONFIG } from '../config/site';

interface ContactProps {
  onRequestResume: () => void;
}

export default function Contact({ onRequestResume }: ContactProps) {
  const linkedinUrl = import.meta.env.VITE_LINKEDIN_URL || SITE_CONFIG.defaultLinkedinUrl;
  const linkedinVanity = import.meta.env.VITE_LINKEDIN_VANITY || SITE_CONFIG.defaultLinkedinVanity;
  const githubUrl = SITE_CONFIG.githubUrl;

  return (
    <section id="contact">
      <div className="wrap">
        <div className="eyebrow">Credentials &amp; Direct Dispatch</div>
        <h2 className="sectitle">Connect &amp; Collaborate</h2>
        <p className="secintro">
          Available for senior backend engineering, enterprise automation, and AI agent architecture opportunities across the UK.
        </p>

        <div className="edu-contact">
          <div className="infocard">
            <div className="gtitle">Education &amp; Background</div>
            <h3 className="infocard-title">Bachelor of Technology (B.Tech.)</h3>
            <p className="infocard-degree">Information Technology · 2020</p>
            <p className="infocard-sub">Dr. A.P.J. Abdul Kalam Technical University (AKTU), India</p>

            <div className="infocard-resume-box">
              <span className="box-label">Verified Résumé Document</span>
              <button
                type="button"
                className="btn-resume-card"
                onClick={onRequestResume}
                aria-label="Request Full Résumé"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                <span>Request Full Résumé</span>
              </button>
            </div>
          </div>

          <div className="infocard">
            <div className="gtitle">Direct Dispatch Channels</div>
            <div className="contactlist">
              <a href={linkedinUrl} target="_blank" rel="noopener noreferrer me" title="Connect on LinkedIn">
                <span>LinkedIn</span>
                <span className="c-val">linkedin.com/in/{linkedinVanity}</span>
              </a>
              <a href={githubUrl} target="_blank" rel="noopener noreferrer me" title="View GitHub Repositories">
                <span>GitHub</span>
                <span className="c-val">github.com/nagendradixit647</span>
              </a>
              <div className="contact-row-static">
                <span>Location</span>
                <span className="c-val">Rugby &amp; Leeds, UK</span>
              </div>
              <div className="contact-row-static">
                <span>Status</span>
                <span className="c-val mono-teal">Active · Open to UK Roles</span>
              </div>
              <div className="contact-row-static">
                <span>Privacy Guard</span>
                <span className="c-val">Zero Contact PII Exposure</span>
              </div>
            </div>
          </div>

          <div className="infocard" data-testid="linkedin-profile-card">
            <div className="gtitle">Professional Profile</div>
            <div className="linkedin-card-top">
              <div className="linkedin-avatar-badge" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.28 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.75M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
                </svg>
              </div>
              <div className="linkedin-meta">
                <h3 className="infocard-title">{SITE_CONFIG.name}</h3>
                <p className="linkedin-vanity">linkedin.com/in/{linkedinVanity}</p>
              </div>
            </div>

            <p className="infocard-sub">
              Senior Backend &amp; Enterprise AI Engineer specializing in Python microservices, pgvector RAG pipelines, and automated IAM architectures.
            </p>

            <div className="infocard-resume-box">
              <span className="box-label">Verified Network Presence</span>
              <a
                href={linkedinUrl}
                target="_blank"
                rel="noopener noreferrer me"
                className="btn-linkedin-card"
                aria-label="Connect with Nagendra Vikram Dixit on LinkedIn (opens in new tab)"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.28 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.75M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
                </svg>
                <span>Connect on LinkedIn</span>
                <span className="cta-arrow" aria-hidden="true">&rarr;</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
